module.exports = __webpack_public_path__ + "img/2B.46657203.jpg";